module.exports = __webpack_public_path__ + "img/ai_teacher_Emily.67465249.png";